<template>
  <div>
    <div style="padding:5px 5px 5px 5px">
      <div id="hello-hello">
        <p style="display:inline;float: left;line-height: 22px;"><b>考勤统计</b></p>

        <el-date-picker v-model="createdTime" type="month" placeholder="选择月" @change="monthChange">
        </el-date-picker>

        <el-select v-model="employeeName" placeholder="选择员工" style="width:220px" @change="monthChange">
          <el-option v-for="item in empList" :key="item.value" :label="item.employeeName" :value="item.userId">
          </el-option>
        </el-select>

        <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
          <el-button round @click="exportExcel">导出</el-button>
          <span>-</span>
        </p>

      </div>
    </div>

    <el-table :data="checkWorkList" style="width: 100%" highlight-current-row v-loading="loading">
      <el-table-column width="45" label-class-name="DisabledSelection">
      </el-table-column>

      <el-table-column prop="employeeName" label="姓名" min-width="10%">
      </el-table-column>
      <el-table-column prop="checkDate" label="日期" min-width="15%">
      </el-table-column>

      <el-table-column prop="onDutyOne" label="上班1" min-width="20%">
      </el-table-column>

      <el-table-column prop="offDutyOne" label="下班1" min-width="20%">
      </el-table-column>

      <el-table-column prop="onDutyTwo" label="上班2" min-width="20%">
      </el-table-column>

      <el-table-column prop="offDutyTwo" label="下班2" min-width="20%">
      </el-table-column>
      <el-table-column prop="onDutyThree" label="上班3" min-width="20%">
      </el-table-column>

      <el-table-column prop="offDutyThree" label="下班3" min-width="20%">
      </el-table-column>

    </el-table>

  </div>
</template>

<script>
import router from '../../router';

export default {
  name: "CheckWorkStatistic",
  data() {
    return {
      token: this.getToken(),
      userId: this.getUserId(),
      companyId: this.getCompanyId(),

      employeeName: '',
      createdTime: new Date(),

      patrolPointId: '',
      empList: [],
      maker: '',

      pageIndex: -1,
      pageNum: -1,

      exportType: '',
      activeName: 'first',
      drawer: false,
      direction: 'rtl',

      loading: false,

      id: '',
      companyName: '',
      checkWorkList: []
    }
  },
  methods: {
    getAllEmp() {

      this.$axios({
        method: "post",
        url: "/shiro/employee/getAll",
        data: {
          pageIndex: -1,
          pageNum: -1,
          companyId: this.companyId
        }, headers: {
          token: this.token
        }
      }).then(result => {

        const data = result.data

        if (data.status === 400) {
          this.$router.push({ path: "/Login" })
        }

        this.empList = data.data

      })
    },
    monthChange() {

      this.loading = true

      this.$axios({
        method: "post",
        url: "/shiro/check/work/getAll",
        data: {
          userId: this.employeeName,
          createdTime: this.createdTime,
          status: -1,
          companyId: this.companyId
        },
        headers: {
          token: this.token
        }
      }).then(result => {

        const data = result.data

        this.checkWorkList = data.data

        this.loading = false
      })
    },
    exportExcel() {

      this.$axios({
        method: "post",
        url: "/shiro/check/work/excel2",
        data: {
          userId: this.employeeName,
          createdTime: this.createdTime,
          companyId: this.companyId
        },
        headers: {
          token: this.token
        },
        responseType: 'arraybuffer'
      }).then(result => {

        const data = result.data

        let objectUrl = result.config.url

        const blob = new Blob([data], { type: 'application/octet-stream' })

        objectUrl = URL.createObjectURL(blob)
        const a = document.createElement("a")
        a.href = objectUrl

        a.download = "考勤统计.xlsx"
        if (this.employeeName == '') {
          a.download = "全员考勤统计.zip"
        }

        a.click()
        a.remove()
        URL.revokeObjectURL(objectUrl)
      })
    }

  },
  mounted() {
    this.setDefaultPath('/checkWorkStatistic')

    this.getAllEmp()
  }
}
</script>

<style></style>